<template>
    <div>
        <choices
                :instantSelection="instantSelection"
                :selectable="isSinglePlayer"
                class="choices"
                v-bind:choices="choices"
                v-on:value="onChooseValue"
        />

        <div class="counter-container" v-if="!isSinglePlayer">
            <counter :current="studentAnswerCount" :total="studentCount" class="counter">Har svaret</counter>
        </div>
    </div>
</template>
<script>
    import PageComponentTemplate from '../page-component-template'
    import Counter from '@/components/counter'
    import Choices from '@/components/choices'
    import {mapGetters} from 'vuex'
    import {$eBus} from '@/event-bus'
    import GameType from '@/enum/GameType'
    import GameClientEvent from '@/enum/GameClientEvent'

    export default {
        name: 'page-component-full-choices',
        extends: PageComponentTemplate,
        components: {
            Counter,
            Choices
        },
        data() {
            return {
                studentCount: 0,
                voteCounts: [],
            }
        },
        mounted() {
            $eBus.$on(GameClientEvent.RoomStateChange, this.onRoomStateChange);

            if (this.$gameClient.room) {
                this.onRoomStateChange(this.$gameClient.room, this.$gameClient.room.state);
            }
        },
        beforeDestroy() {
            $eBus.$off(GameClientEvent.RoomStateChange, this.onRoomStateChange);
        },
        methods: {
            onRoomStateChange(room, state) {
                if (state.hasOwnProperty('studentCount')) {
                    this.studentCount = state.studentCount;
                }

                if (state.hasOwnProperty('voteCounts')) {
                    this.voteCounts = state.voteCounts;
                }
            },
            onChooseValue(val) {
                if (this.instantSelection) {
                    this.$emit('pickChoice', this.choices[val])
                }
            }
        },
        computed: {
            ...mapGetters({
                gameType: 'getGameType'
            }),
            isSinglePlayer() {
                return this.gameType === GameType.SinglePlayer;
            },
            choices() {
                if (this.options && this.options.hasOwnProperty('choices')) {
                    return this.options.choices
                }

                return []
            },
            studentAnswerCount() {
                // Add up all the votes to get the total count
                let studentAnswerCount = 0;

                for (let i = 0, len = this.voteCounts.length; i < len; i++) {
                    let voteCount = this.voteCounts[i];

                    studentAnswerCount += voteCount.vote;
                }

                return studentAnswerCount;
            },
            instantSelection() {
                return this.isSinglePlayer;
            }
        },
    }
</script>
<style lang="less" scoped>
    .counter {
        margin: 30px auto 0 auto;
    }
</style>